import { combineReducers } from 'redux-immutable';
import { eventServicesReducer } from './events/reducers';
import {
  createResourceReducer,
  resourceChangeStatusReducer,
  resourcesTableReducer,
  updateResourceReducer,
} from './resources/reducers';
import getSenderAvailabilityReducer from './senderAvailability/reducers';

export const rootBookingModuleReducer = combineReducers({
  resourcesTable: resourcesTableReducer,
  resourceChangeStatusAction: resourceChangeStatusReducer,
  createResourceForm: createResourceReducer,
  updateResourceForm: updateResourceReducer,
  eventServices: eventServicesReducer,
  senderAvailability: getSenderAvailabilityReducer,
});
